import { CashTypeEnum } from "../enums/CashTypeEnum";
import { TransactionFlowEnum } from "../enums/TransactionFlowEnum";
import { TransactionTypeEnum } from "../enums/TransactionTypeEnum";

export class TransactionBagDetails {
    public transactionId: string;
    public transactionTimestamp: Date;
    public transactionType: TransactionTypeEnum;
    public installationName: string;
    public machineId: number;
    public currency: string;
    public cashType: CashTypeEnum;
    public flow: TransactionFlowEnum;
    public bagId: string;
    public bagPosition: number;
    public cashValue: number;
    public pieces: number;

    constructor() {}

    parse(obj: any) {
        this.transactionId = obj.TransactionId;
        if (obj.TransactionTimestamp) this.transactionTimestamp = obj.TransactionTimestamp;
        if (obj.TransactionType != null && Object.values(TransactionTypeEnum).includes(obj.TransactionType)) this.transactionType = obj.TransactionType;
        this.installationName = obj.InstallationName;
        this.machineId = obj.MachineId;
        this.currency = obj.Currency;
        if (obj.CashType != null && Object.values(CashTypeEnum).includes(obj.CashType)) this.cashType = obj.CashType;
        if (obj.Flow != null && Object.values(TransactionFlowEnum).includes(obj.Flow)) this.flow = obj.Flow;
        this.bagId = obj.BagId;
        this.bagPosition = obj.BagPosition;
        this.cashValue = obj.CashValue;
        this.pieces = obj.Pieces;
    }
}
